import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { Grid, Header, Form, Radio, Segment } from 'semantic-ui-react';
import {
  getInvoicing,
  getInvoiceLines,
  getIndexationPercentage,
  getBalanceInvoiceCreateAction,
  getBalanceInvoiceDate,
  getBalanceInvoicePaymentDate,
  getBalanceInvoicePaymentCondition,
  getBalanceInvoicePaymentFrequency,
  getInitialDuration,
  getErrors,
  getLastInvoiceAmount,
  getLastInvoiceIssueDate,
} from '../reducers/form';
import { fetchFormIfNeeded, updateData } from '../actions/form';
import { isFetching } from '../reducers/index';
import AASTBillDetail from 'saas/common/bill/AASTBillDetail';
import RenewInvoice from './RenewInvoice';

export class Invoicing extends React.Component {
  componentWillMount() {
    this.props.fetchForm(this.props.contractId);
  }

  render() {
    const {
      invoicing,
      invoiceLines,
      lastInvoiceAmount,
      lastInvoiceIssueDate,
      indexationPercentage,
      balanceInvoiceCreateAction,
      balanceInvoiceDate,
      balanceInvoicePaymentDate,
      balanceInvoicePaymentCondition,
      balanceInvoiceType,
      balanceInvoicePaymentFrequency,
      initialDuration,
      isExisting,
      errors,
    } = this.props;

    const radioLabel = value => {
      return value ? 'Désactiver' : 'Activer';
    };

    const onValueChanged = (field, value) => {
      this.props.updateGenericData(field, value);
    };

    const balanceInvoiceTypeOptions = () => {
      let options = [
        {
          text: 'Installation',
          value: 'INSTALL_ONLY',
        },
      ];

      if (initialDuration) {
        let text = '';

        if (initialDuration === 1) {
          text = `Installation et ${initialDuration} an de maintenance`;
        } else {
          text = `Installation et ${initialDuration} ans de maintenance`;
        }

        options.push({
          text: text,
          value: 'INSTALL_AND_MAINTENANCE',
        });
      }
      return options;
    };

    const mustDisplayLastInvoicing = () => {
      const selectedValue = balanceInvoiceTypeOptions().find(
        r => r.value === balanceInvoiceType
      );

      return (
        (!isExisting && selectedValue) ||
        (lastInvoiceAmount && lastInvoiceIssueDate)
      );
    };

    const renderInvoiceType = () => {
      const selectedValue = balanceInvoiceTypeOptions().find(
        r => r.value === balanceInvoiceType
      );
      if (selectedValue) {
        return <div className="text">{selectedValue.text}</div>;
      }
      return <div className="default text" />;
    };

    const displayLastInvoiceInformations = () => {
      if (lastInvoiceAmount && lastInvoiceIssueDate) {
        return `${lastInvoiceAmount} € facture émise le ${lastInvoiceIssueDate}`;
      }
      return '';
    };

    if (!this.props.isFetching) {
      return (
        <Segment>
          <Form.Field inline>
            <label>
              <Header size="medium">Facturation</Header>
            </label>
            <Radio
              toggle
              name="invoicing"
              label={radioLabel(invoicing)}
              checked={invoicing}
              onChange={this.props.updateInvoicing}
            />
          </Form.Field>
          {invoicing && (
            <div>
              {mustDisplayLastInvoicing() === 1 && (
                <Segment>
                  <Header size="tiny">
                    Rappel des éléments de facturation
                  </Header>
                  <Grid columns={2} divided>
                    <Grid.Row>
                      {!isExisting && (
                        <Grid.Column>
                          <Form.Field>
                            <label>Facturé la première année</label>
                            {renderInvoiceType()}
                          </Form.Field>
                        </Grid.Column>
                      )}
                      <Grid.Column>
                        <Form.Field>
                          <label>Montant HT de la facture précédente</label>
                          {displayLastInvoiceInformations()}
                        </Form.Field>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              )}
              <Segment>
                <RenewInvoice
                  onValueChange={onValueChanged}
                  invoiceLines={invoiceLines}
                  indexationPercentage={indexationPercentage}
                  invoiceCreateAction={balanceInvoiceCreateAction}
                  invoiceDate={balanceInvoiceDate}
                  invoicePaymentDate={balanceInvoicePaymentDate}
                  invoicePaymentCondition={balanceInvoicePaymentCondition}
                  invoiceType={balanceInvoiceType}
                  invoicePaymentFrequency={balanceInvoicePaymentFrequency}
                  onInvoiceLinesChange={this.props.updateInvoiceLines}
                  errors={errors}
                />
                <Header size="tiny">
                  Vérifier et corriger la prochaine facture à émettre
                </Header>
                <AASTBillDetail
                  lines={invoiceLines}
                  onChange={this.props.updateInvoiceLines}
                  hideDepositPercentage
                  isRenew
                />
              </Segment>
            </div>
          )}
        </Segment>
      );
    } else {
      return (
        <div
          className="ui active loading segment"
          style={{ minHeight: '180px' }}
        />
      );
    }
  }
}

Invoicing.propTypes = {
  invoiceLines: PropTypes.array.isRequired,
  invoicing: PropTypes.bool.isRequired,
  indexationPercentage: PropTypes.number,
  lastInvoiceAmount: PropTypes.number,
  lastInvoiceIssueDate: PropTypes.string,
  balanceInvoiceCreateAction: PropTypes.bool.isRequired,
  balanceInvoiceDate: PropTypes.string,
  balanceInvoicePaymentDate: PropTypes.string,
  balanceInvoicePaymentCondition: PropTypes.string.isRequired,
  balanceInvoicePaymentFrequency: PropTypes.number.isRequired,
  fetchForm: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  updateInvoicing: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  initialDuration: getInitialDuration(state),
  invoicing: getInvoicing(state),
  invoiceLines: getInvoiceLines(state),
  indexationPercentage: getIndexationPercentage(state),
  lastInvoiceAmount: getLastInvoiceAmount(state),
  lastInvoiceIssueDate: getLastInvoiceIssueDate(state),
  balanceInvoiceCreateAction: getBalanceInvoiceCreateAction(state),
  balanceInvoiceDate: getBalanceInvoiceDate(state),
  balanceInvoicePaymentDate: getBalanceInvoicePaymentDate(state),
  balanceInvoicePaymentCondition: getBalanceInvoicePaymentCondition(state),
  balanceInvoicePaymentFrequency: getBalanceInvoicePaymentFrequency(state),
  errors: getErrors(state),
  isFetching: isFetching(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchForm: id => dispatch(fetchFormIfNeeded(id)),
  updateInvoicing: (_, value) =>
    dispatch(updateData('invoicingInformations.invoicing', value.checked)),
  updateInvoiceLines: lines =>
    dispatch(updateData('invoicingInformations.invoiceLines', lines)),
  updateGenericData: (field, value) => dispatch(updateData(field, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Invoicing);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/renew/components/Invoicing.js